document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('form').forEach(form => {
    const button = form.querySelector('.ai-featured-collection-add-to-cart-atw1lvldraxp6ze1zwaigenblock3624fd0ahged9');
    if (button) {
      form.addEventListener('submit', function(e) {
        e.preventDefault(); // page reload ko rok do
        
        const formData = new FormData(form);
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(item => {
          console.log('Added to cart:', item);
          alert(item.title + ' added to cart!'); // user ko notification
          updateCartQuantity();
        })
        .catch(error => console.error('Error adding to cart:', error));
      });
    }
  });

  // Update header cart quantity
  function updateCartQuantity() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const countEl = document.querySelector('#cart-count'); 
        if(countEl) countEl.textContent = cart.item_count;
      });
  }
});
